module.exports = __webpack_public_path__ + "static/gift-offer-fa833179046f6cebe64f3a2cc1694c1c.png";